module.exports = __webpack_public_path__ + "static/media/btn-update.bfb9a4a1.svg";